import { createStyles } from '@mantine/core';

import Dialog from '~/domains/design-system/components/Dialog/Dialog';
import DialogBody from '~/domains/design-system/components/Dialog/DialogBody/DialogBody';

import WithdrawalView from './WithdrawalView';
import withTaxInformation from './hocs/withTaxInformation';

const useStyles = createStyles((theme) => ({
  container: {
    width: 780,

    [theme.fn.smallerThan('sm')]: {
      width: '100%',
      maxHeight: 'calc(100dvh - 24px)',
      overflowY: 'auto',
    },
  },
}));

type WithdrawalModalProps = {
  isOpen?: boolean;
  onClose: VoidFunction;
};

function WithdrawalModal({ isOpen = true, onClose }: WithdrawalModalProps) {
  const { classes } = useStyles();

  return (
    <Dialog
      onClose={onClose}
      isOpen={isOpen}
      type={{
        desktop: 'modal',
        mobile: 'drawer',
      }}
      className={classes.container}
    >
      <DialogBody>
        <WithdrawalView onContinue={onClose} />
      </DialogBody>
    </Dialog>
  );
}

export default withTaxInformation(WithdrawalModal);
